import {
  canonicalCopilotAgentsConversationRoute,
  copilotAgentsConversationRoute,
} from './copilot-agents-conversation-route'
import {canonicalCopilotAgentsRoute, copilotAgentsRoute} from './copilot-agents-route'
import {canonicalCopilotAgentsNewSpaceRoute, copilotAgentsNewSpaceRoute} from './spaces/copilot-agents-new-space-route'
import {canonicalCopilotAgentsSpaceRoute, copilotAgentsSpaceRoute} from './spaces/copilot-agents-space-route'
import {canonicalCopilotAgentsSpacesRoute, copilotAgentsSpacesRoute} from './spaces/copilot-agents-spaces-route'

export function getCopilotAgentsRouteSet(quickChatEnabled: boolean) {
  return quickChatEnabled
    ? {
        agents: canonicalCopilotAgentsRoute,
        conversation: canonicalCopilotAgentsConversationRoute,
        spaces: canonicalCopilotAgentsSpacesRoute,
        newSpace: canonicalCopilotAgentsNewSpaceRoute,
        space: canonicalCopilotAgentsSpaceRoute,
      }
    : {
        agents: copilotAgentsRoute,
        conversation: copilotAgentsConversationRoute,
        spaces: copilotAgentsSpacesRoute,
        newSpace: copilotAgentsNewSpaceRoute,
        space: copilotAgentsSpaceRoute,
      }
}
